<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        :disabled="disabled"
        :value="computedDateFormattedMomentjs"
        :label="$attrs.label ? $attrs.label : label"
        clearable
        @click:clear="currentDate = null"
        persistent-hint
        v-on="on"
        readonly
        :error-messages="errorMessages"
      ></v-text-field>
    </template>
    <v-date-picker
      v-if="!disabled"
      v-model="currentDate"
      no-title
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import moment from "moment";
export default {
  name: "DatePicker",
  data: function() {
    return {
      currentDate: null,
      menu: false,
      label: "Date"
    };
  },
  props: {
    value: null,
    disabled: null,
    errorMessages: null
  },
  mounted() {
    this.currentDate = this.value;
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.currentDate
        ? moment(this.currentDate).format("DD.MM.YYYY")
        : "";
    }
  },
  watch: {
    currentDate: function(val) {
      this.$emit("input", val);
    },
    value: function(val) {
      this.currentDate = val;
    }
  },
  methods: {
    setDate() {
      const date = this.$refs.datePicker.value;
      const myMomentObject = moment(date, "DD.MM.YYYY", true);
    }
  }
};
</script>
